module.exports = __webpack_public_path__ + "e2d9e9688211fac2089e8dc77c36ff97.png";